export default {
    name: "EventSender",
    methods: {
        fire: (eventName, params) => this.notifyEvent(eventName, params),
        notifyEvent(eventName, params) {
            console.log(eventName);
            this.$listenerEventBus.$emit(eventName, params);
        }
    }
}